import { KoobInputSelect } from '@koob/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Room switcher for the night-rates grid. `null` (the ALL_ROOMS sentinel) keeps
// every room of the contract on screen — the grid's original behaviour — and a
// concrete id narrows it to that room. The value is the room's grid id (the
// hotelRoomContract id), the same key the selection checkboxes are built on.
export const ALL_ROOMS = '';

export default function NightRatesRoomSelector({ rooms, roomId, setRoomId }) {
  const { t } = useTranslation('contracts');

  const options = useMemo(
    () => [
      { label: t('nightRatesEditor.allRooms'), value: ALL_ROOMS },
      ...(rooms ?? []).map((room) => ({ label: room.name, value: room.id })),
    ],
    [rooms, t],
  );

  return (
    <KoobInputSelect
      value={roomId ?? ALL_ROOMS}
      onValueChange={(value) => setRoomId(value === ALL_ROOMS ? null : value)}
      options={options}
      placeholder={t('nightRatesEditor.allRooms')}
    />
  );
}
